import { render, staticRenderFns } from "./UpdatePopover.vue?vue&type=template&id=1f06141a&"
import script from "./UpdatePopover.vue?vue&type=script&lang=js&"
export * from "./UpdatePopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports